import api from "../config/api";

export const getAllVendorAdvanceDeductions = async () => {
    const res = await api.get('/vendorAdvanceDeduction/');
    return res.data;
};

export const getVendorAdvanceDeductionsByVendor = async (vendor_id) => {
    const res = await api.get(`/vendorAdvanceDeduction/?vendor_id=${vendor_id}`);
    return res.data;
};

export const getVendorAdvanceDeductionsByDate = async (date) => {
    const res = await api.get(`/vendorAdvanceDeduction/?date=${date}`);
    return res.data;
};

export const getVendorAdvanceDeductionsByVendorDate = async (vendor_id, date) => {
    const res = await api.get(`/vendorAdvanceDeduction/?vendor_id=${vendor_id}&date=${date}`);
    return res.data;
};

export const saveVendorAdvanceDeduction = async (payload) => {
    const res = await api.post(
        `/vendorAdvanceDeduction/`,
        payload,
        { headers: { "Content-Type": "application/json" } }
    );
    return res.data;
};
export const deleteVendorAdvanceDeduction = async (id) => {
    const res = await api.delete(`/vendorAdvanceDeduction/?id=${id}`);
    return res.data;
};
